// Looker Dashboard Configuration
// Update URLs and names based on your actual Looker dashboards

export const analyticsTabsConfig = [
  {
    id: 'general-metrics',
    name: {
      es: 'Métricas Generales',
      ca: 'Mètriques Generals', 
      en: 'General Metrics',
      fr: 'Métriques Générales',
      pt: 'Métricas Gerais'
    },
    description: {
      es: 'TMA, Ocupación, Porcentajes de atención',
      ca: 'TMA, Ocupació, Percentatges d\'atenció',
      en: 'AHT, Occupancy, Attention percentages',
      fr: 'TMT, Occupation, Pourcentages d\'attention',
      pt: 'TMA, Ocupação, Percentagens de atenção'
    },
    icon: 'BarChart3',
    url: 'https://placeholder-dashboard-general-metrics.example.com/embed/dashboards/general',
    // Replace with your actual dashboard URL for general metrics
    actualUrl: 'https://lookerstudio.google.com/embed/reporting/383eb531-c54f-4e82-b53c-4760be003fcc/page/qgR',
    metrics: ['TMA', 'Ocupació', 'Percentatges atenció', 'Estat llamades']
  },
  {
    id: 'temporal-analysis',
    name: {
      es: 'Análisis Temporal',
      ca: 'Anàlisi Temporal',
      en: 'Temporal Analysis',
      fr: 'Analyse Temporelle',
      pt: 'Análise Temporal'
    },
    description: {
      es: 'Franjas horarias y detalles por intervalos',
      ca: 'Franges horàries i detalls per intervals', 
      en: 'Time slots and interval details',
      fr: 'Créneaux horaires et détails par intervalles',
      pt: 'Faixas horárias e detalhes por intervalos'
    },
    icon: 'Activity',
    url: 'https://placeholder-dashboard-temporal.example.com/embed/dashboards/temporal',
    actualUrl: '',
    metrics: ['Franges horàries', 'Intervals', 'Tendències temporals']
  },
  {
    id: 'ddi-campaigns',
    name: {
      es: 'Campañas DDI',
      ca: 'Campanyes DDI',
      en: 'DDI Campaigns',
      fr: 'Campagnes DDI',
      pt: 'Campanhas DDI'
    },
    description: {
      es: 'Resultados por campaña y descripción DDI',
      ca: 'Resultats per campanya i descripció DDI',
      en: 'Campaign results and DDI description',
      fr: 'Résultats par campagne et description DDI',
      pt: 'Resultados por campanha e descrição DDI'
    },
    icon: 'MessageSquare',
    url: 'https://placeholder-dashboard-ddi.example.com/embed/dashboards/ddi',
    actualUrl: '',
    metrics: ['DDI Description', 'Recibidas', 'Atendidas', 'Abandonadas', 'NDA']
  },
  {
    id: 'conversion-kpis',
    name: {
      es: 'Conversión y KPIs',
      ca: 'Conversió i KPIs',
      en: 'Conversion & KPIs',
      fr: 'Conversion et KPI',
      pt: 'Conversão e KPIs'
    },
    description: {
      es: 'Métricas de conversión e indicadores clave',
      ca: 'Mètriques de conversió i indicadors clau',
      en: 'Conversion metrics and key indicators',
      fr: 'Métriques de conversion et indicateurs clés',
      pt: 'Métricas de conversão e indicadores-chave'
    },
    icon: 'Target',
    url: 'https://placeholder-dashboard-conversion.example.com/embed/dashboards/conversion',
    actualUrl: '',
    metrics: ['Conversió', 'KPIs', 'Percentatges de contacte', 'Resultats']
  }
];

export const reportsTabsConfig = [
  {
    id: 'campaign-performance',
    name: {
      es: 'Rendimiento de Campañas',
      ca: 'Rendiment de Campanyes',
      en: 'Campaign Performance',
      fr: 'Performance des Campagnes',
      pt: 'Desempenho de Campanhas'
    },
    description: {
      es: 'Análisis detallado del rendimiento de campañas',
      ca: 'Anàlisi detallada del rendiment de campanyes',
      en: 'Detailed campaign performance analysis',
      fr: 'Analyse détaillée des performances de campagne',
      pt: 'Análise detalhada do desempenho de campanhas'
    },
    icon: 'FileText',
    url: 'https://placeholder-reports-campaigns.example.com/embed/reports/campaigns',
    actualUrl: '',
    metrics: ['Rendiment', 'ROI', 'Conversions', 'Costos']
  },
  {
    id: 'conversational-quality',
    name: {
      es: 'Calidad Conversacional',
      ca: 'Qualitat Conversacional', 
      en: 'Conversational Quality',
      fr: 'Qualité Conversationnelle',
      pt: 'Qualidade Conversacional'
    },
    description: {
      es: 'Análisis de calidad de conversaciones y transcripciones',
      ca: 'Anàlisi de qualitat de converses i transcripcions',
      en: 'Conversation quality and transcription analysis',
      fr: 'Analyse de la qualité des conversations et transcriptions',
      pt: 'Análise da qualidade de conversações e transcrições'
    },
    icon: 'MessageSquare',
    url: 'https://placeholder-reports-quality.example.com/embed/reports/quality',
    actualUrl: '',
    metrics: ['Qualitat', 'Satisfacció client', 'Índex claredat', 'Compliment']
  },
  {
    id: 'agent-performance',
    name: {
      es: 'Rendimiento de Agentes',
      ca: 'Rendiment d\'Agents',
      en: 'Agent Performance',
      fr: 'Performance des Agents',
      pt: 'Desempenho de Agentes'
    },
    description: {
      es: 'Métricas de rendimiento individual de agentes',
      ca: 'Mètriques de rendiment individual d\'agents',
      en: 'Individual agent performance metrics',
      fr: 'Métriques de performance individuelle des agents',
      pt: 'Métricas de desempenho individual de agentes'
    },
    icon: 'Users',
    url: 'https://placeholder-reports-agents.example.com/embed/reports/agents',
    actualUrl: '',
    metrics: ['Agents', 'Productivitat', 'Qualitat', 'Eficiència']
  },
  {
    id: 'osint-monitoring',
    name: {
      es: 'Monitorización OSINT',
      ca: 'Monitorització OSINT',
      en: 'OSINT Monitoring',
      fr: 'Surveillance OSINT',
      pt: 'Monitorização OSINT'
    },
    description: {
      es: 'Informes de monitorización y análisis reputacional',
      ca: 'Informes de monitorització i anàlisi reputacional',
      en: 'Monitoring and reputation analysis reports',
      fr: 'Rapports de surveillance et d\'analyse réputationnelle',
      pt: 'Relatórios de monitorização e análise reputacional'
    },
    icon: 'Shield',
    url: 'https://placeholder-reports-osint.example.com/embed/reports/osint',
    actualUrl: '',
    metrics: ['Mencions', 'Sentiment', 'Reputació', 'Alertes']
  }
];

// Helper function to get tab configuration with current language
export const getTabsConfig = (type, language = 'ca', clientConfig = null) => {
  const config = type === 'analytics' ? analyticsTabsConfig : reportsTabsConfig;

  // Intentar leer URLs específicas por pestaña desde settings del cliente
  // Estructura esperada: settings.looker_dashboard_urls = { 'general-metrics': 'https://...', 'temporal-analysis': 'https://...', ... }
  const perTabUrls = clientConfig?.settings?.looker_dashboard_urls || null;

  return config.map(tab => {
    const localized = {
      ...tab,
      name: tab.name[language] || tab.name.ca || tab.name.en,
      description: tab.description[language] || tab.description.ca || tab.description.en
    };

    // Prioridad de URL:
    // 1) URL específica por pestaña en settings
    // 2) URL única del cliente (looker_dashboard_url)
    // 3) actualUrl del tab
    // 4) url placeholder del tab
    const urlFromSettings = perTabUrls && perTabUrls[tab.id] ? perTabUrls[tab.id] : null;
    const url = urlFromSettings || clientConfig?.looker_dashboard_url || tab.actualUrl || tab.url;

    return { ...localized, url };
  });
};

// Helper function to get campaign-specific dashboard configuration
export const getCampaignDashboardConfig = (campaign, language = 'ca') => {
  // Si la campaña tiene una URL específica de Looker, usarla
  if (campaign.looker_dashboard_url) {
    return {
      id: 'campaign-specific',
      name: {
        es: 'Dashboard de Campaña',
        ca: 'Dashboard de Campanya',
        en: 'Campaign Dashboard',
        fr: 'Tableau de bord de campagne',
        pt: 'Dashboard da Campanha'
      },
      description: {
        es: `Dashboard personalizado para ${campaign.name}`,
        ca: `Dashboard personalitzat per ${campaign.name}`,
        en: `Custom dashboard for ${campaign.name}`,
        fr: `Tableau de bord personnalisé pour ${campaign.name}`,
        pt: `Dashboard personalizado para ${campaign.name}`
      },
      icon: 'BarChart3',
      url: campaign.looker_dashboard_url,
      isCampaignSpecific: true
    };
  }

  // Si no tiene URL específica, usar configuración por defecto basada en el tipo
  const defaultConfig = getDefaultCampaignTabs(campaign.type, campaign.id, language);

  return defaultConfig.map(tab => ({
    ...tab,
    name: tab.name[language] || tab.name.ca || tab.name.en,
    description: tab.description[language] || tab.description.ca || tab.description.en,
    isCampaignSpecific: false
  }));
};

// Default campaign tabs based on campaign type
const getDefaultCampaignTabs = (campaignType, campaignId, language = 'ca') => {
  const baseUrl = 'https://lookerstudio.google.com/embed/reporting/383eb531-c54f-4e82-b53c-4760be003fcc/page/qgR';

  switch (campaignType) {
    case 'sales':
      return [
        {
          id: 'sales-funnel',
          name: {
            es: 'Embudo de Ventas',
            ca: 'Embut de Vendes',
            en: 'Sales Funnel',
            fr: 'Entonnoir de Ventes',
            pt: 'Funil de Vendas'
          },
          description: {
            es: 'Análisis del proceso de conversión de leads',
            ca: 'Anàlisi del procés de conversió de leads',
            en: 'Lead conversion process analysis',
            fr: 'Analyse du processus de conversion des prospects',
            pt: 'Análise do processo de conversão de leads'
          },
          icon: 'Target',
          url: `${baseUrl}?campaign=${campaignId}&type=sales-funnel`
        },
        {
          id: 'performance',
          name: {
            es: 'Rendimiento de Ventas',
            ca: 'Rendiment de Vendes',
            en: 'Sales Performance',
            fr: 'Performance des Ventes',
            pt: 'Performance de Vendas'
          },
          description: {
            es: 'KPIs y métricas de performance de ventas',
            ca: 'KPIs i mètriques de rendiment de vendes',
            en: 'Sales KPIs and performance metrics',
            fr: 'KPI et métriques de performance des ventes',
            pt: 'KPIs e métricas de performance de vendas'
          },
          icon: 'TrendingUp',
          url: `${baseUrl}?campaign=${campaignId}&type=performance`
        },
        {
          id: 'geographic',
          name: {
            es: 'Distribución Geográfica',
            ca: 'Distribució Geogràfica',
            en: 'Geographic Distribution',
            fr: 'Distribution Géographique',
            pt: 'Distribuição Geográfica'
          },
          description: {
            es: 'Análisis de ventas por ubicación geográfica',
            ca: 'Anàlisi de vendes per ubicació geogràfica',
            en: 'Sales analysis by geographic location',
            fr: 'Analyse des ventes par localisation géographique',
            pt: 'Análise de vendas por localização geográfica'
          },
          icon: 'MapPin',
          url: `${baseUrl}?campaign=${campaignId}&type=geographic`
        }
      ];
    case 'collections':
      return [
        {
          id: 'recovery-rates',
          name: {
            es: 'Tasas de Recuperación',
            ca: 'Taxes de Recuperació',
            en: 'Recovery Rates',
            fr: 'Taux de Récupération',
            pt: 'Taxas de Recuperação'
          },
          description: {
            es: 'Análisis de efectividad en cobranza',
            ca: 'Anàlisi d\'efectivitat en cobrament',
            en: 'Collection effectiveness analysis',
            fr: 'Analyse d\'efficacité de recouvrement',
            pt: 'Análise de efetividade em cobrança'
          },
          icon: 'Target',
          url: `${baseUrl}?campaign=${campaignId}&type=recovery-rates`
        },
        {
          id: 'payment-patterns',
          name: {
            es: 'Patrones de Pago',
            ca: 'Patrons de Pagament',
            en: 'Payment Patterns',
            fr: 'Modèles de Paiement',
            pt: 'Padrões de Pagamento'
          },
          description: {
            es: 'Análisis de comportamiento de pago',
            ca: 'Anàlisi de comportament de pagament',
            en: 'Payment behavior analysis',
            fr: 'Analyse du comportement de paiement',
            pt: 'Análise de comportamento de pagamento'
          },
          icon: 'BarChart3',
          url: `${baseUrl}?campaign=${campaignId}&type=payment-patterns`
        },
        {
          id: 'contact-optimization',
          name: {
            es: 'Optimización de Contacto',
            ca: 'Optimització de Contacte',
            en: 'Contact Optimization',
            fr: 'Optimisation de Contact',
            pt: 'Otimização de Contato'
          },
          description: {
            es: 'Mejores horarios y canales de contacto',
            ca: 'Millors horaris i canals de contacte',
            en: 'Best contact times and channels',
            fr: 'Meilleurs horaires et canaux de contact',
            pt: 'Melhores horários e canais de contato'
          },
          icon: 'Clock',
          url: `${baseUrl}?campaign=${campaignId}&type=contact-optimization`
        }
      ];
    case 'retention':
      return [
        {
          id: 'retention-metrics',
          name: {
            es: 'Métricas de Retención',
            ca: 'Mètriques de Retenció',
            en: 'Retention Metrics',
            fr: 'Métriques de Rétention',
            pt: 'Métricas de Retenção'
          },
          description: {
            es: 'Análisis de retención de clientes',
            ca: 'Anàlisi de retenció de clients',
            en: 'Customer retention analysis',
            fr: 'Analyse de rétention client',
            pt: 'Análise de retenção de clientes'
          },
          icon: 'Users',
          url: `${baseUrl}?campaign=${campaignId}&type=retention-metrics`
        },
        {
          id: 'churn-analysis',
          name: {
            es: 'Análisis de Abandono',
            ca: 'Anàlisi d\'Abandonament',
            en: 'Churn Analysis',
            fr: 'Analyse d\'Attrition',
            pt: 'Análise de Churn'
          },
          description: {
            es: 'Factores que influyen en el churn',
            ca: 'Factors que influeixen en l\'abandonament',
            en: 'Factors influencing churn',
            fr: 'Facteurs influençant l\'attrition',
            pt: 'Fatores que influenciam o churn'
          },
          icon: 'AlertCircle',
          url: `${baseUrl}?campaign=${campaignId}&type=churn-analysis`
        },
        {
          id: 'loyalty-insights',
          name: {
            es: 'Insights de Lealtad',
            ca: 'Insights de Lleialtat',
            en: 'Loyalty Insights',
            fr: 'Insights Fidélité',
            pt: 'Insights de Fidelidade'
          },
          description: {
            es: 'Análisis de programa de lealtad',
            ca: 'Anàlisi de programa de lleialtat',
            en: 'Loyalty program analysis',
            fr: 'Analyse du programme de fidélité',
            pt: 'Análise do programa de fidelidade'
          },
          icon: 'Activity',
          url: `${baseUrl}?campaign=${campaignId}&type=loyalty-insights`
        }
      ];
    default:
      return [
        {
          id: 'general-metrics',
          name: {
            es: 'Métricas Generales',
            ca: 'Mètriques Generals',
            en: 'General Metrics',
            fr: 'Métriques Générales',
            pt: 'Métricas Gerais'
          },
          description: {
            es: 'Vista general del rendimiento de la campaña',
            ca: 'Vista general del rendiment de la campanya',
            en: 'General campaign performance overview',
            fr: 'Vue générale des performances de campagne',
            pt: 'Visão geral do desempenho da campanha'
          },
          icon: 'BarChart3',
          url: `${baseUrl}?campaign=${campaignId}&type=general-metrics`
        },
        {
          id: 'contact-analysis',
          name: {
            es: 'Análisis de Contactos',
            ca: 'Anàlisi de Contactes',
            en: 'Contact Analysis',
            fr: 'Analyse de Contacts',
            pt: 'Análise de Contatos'
          },
          description: {
            es: 'Análisis detallado de contactos realizados',
            ca: 'Anàlisi detallat de contactes realitzats',
            en: 'Detailed analysis of contacts made',
            fr: 'Analyse détaillée des contacts effectués',
            pt: 'Análise detalhada de contatos realizados'
          },
          icon: 'Phone',
          url: `${baseUrl}?campaign=${campaignId}&type=contact-analysis`
        },
        {
          id: 'time-analysis',
          name: {
            es: 'Análisis Temporal',
            ca: 'Anàlisi Temporal',
            en: 'Time Analysis',
            fr: 'Analyse Temporelle',
            pt: 'Análise Temporal'
          },
          description: {
            es: 'Patrones temporales de la campaña',
            ca: 'Patrons temporals de la campanya',
            en: 'Campaign temporal patterns',
            fr: 'Modèles temporels de campagne',
            pt: 'Padrões temporais da campanha'
          },
          icon: 'Clock',
          url: `${baseUrl}?campaign=${campaignId}&type=time-analysis`
        }
      ];
  }
};

// Configuration for easy updates
export const dashboardConfig = {
  // Set this to true when you have actual Looker URLs
  useActualUrls: true,
  
  // Add your actual Looker embed URLs here
  actualUrls: {
    'general-metrics': 'https://lookerstudio.google.com/embed/reporting/383eb531-c54f-4e82-b53c-4760be003fcc/page/qgR',
    'temporal-analysis': '',
    'ddi-campaigns': '',
    'conversion-kpis': '',
    'campaign-performance': '',
    'conversational-quality': '',
    'agent-performance': '',
    'osint-monitoring': ''
  }
};